var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrois(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 56,
    viewBox: "0 0 45 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_i_208_657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01969 21.4427L13.9611 10.4849C19.7408 3.40177 22.6306 -0.139792 25.1253 0.757531C27.62 1.65485 27.4041 6.15819 26.9722 15.1649L26.9314 16.0141C26.7757 19.2626 26.6978 20.8868 27.6869 21.9554L27.7393 22.0109C28.7518 23.059 30.4423 23.1401 33.8234 23.3022C39.9077 23.594 42.9498 23.7399 43.8895 25.6344C43.9051 25.6658 43.9201 25.6974 43.9347 25.7292C44.8154 27.6495 42.9397 29.9482 39.1883 34.5456L30.2469 45.5033C24.4671 52.5864 21.5772 56.128 19.0825 55.2307C16.5878 54.3333 16.8038 49.8299 17.2359 40.8232L17.2766 39.9743C17.4324 36.7258 17.5103 35.1015 16.5212 34.0329L16.4688 33.9775C15.4562 32.9293 13.7657 32.8482 10.3847 32.6861C4.30036 32.3943 1.25822 32.2484 0.318565 30.3539C0.303008 30.3225 0.287935 30.2909 0.273354 30.2591C-0.607349 28.3388 1.26833 26.0401 5.01969 21.4427Z",
    fill: "url(#paint0_radial_208_657)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_208_657",
    x: 0.0585938,
    y: 0.620605,
    width: 44.0918,
    height: 58.7471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_208_657"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_208_657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.5 3) rotate(58.7004) scale(73.1454 58.5163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616655,
    stopColor: "#33CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#282828"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrois);
export default __webpack_public_path__ + "static/media/trois.b5be6df15fcc1ee096edd280d95871f5.svg";
export { ForwardRef as ReactComponent };